// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Form, Input, Tooltip } from "antd";

interface PropsType {
  labelName: string;
  inputId?: string;
  defaultValue?: string;
  required?: boolean;
  emptyErrorMessage?: string;
  placeholder?: string;
  labelTooltip?: string | null;
  readOnly?: boolean;
  labelClassName?: string;
  fieldClassName?: string;
  maxLength?: number;
  onChange?: (e: any) => void;
  type?: string;
  addonAfter?: string;
  textArea?: boolean;
  minRows?: number;
}

const FormField: React.FunctionComponent<PropsType> = (props: PropsType) => {
  const {
    labelName,
    labelTooltip,
    inputId,
    required,
    emptyErrorMessage,
    placeholder,
    readOnly,
    labelClassName,
    fieldClassName,
    onChange,
    maxLength,
    type,
    addonAfter,
    textArea,
    defaultValue,
    minRows = 3
  } = props;

  const isRequired: boolean = !!readOnly ? false : !!required; // !(!var) => return false if var = false | null | undefined

  return (
    <>
      <Form.Item
        name={inputId}
        key={labelName}
        label={
          <span className={labelClassName ? labelClassName : ""}>
            {labelName}&nbsp;
            {labelTooltip && <Tooltip title={labelTooltip} />}
          </span>
        }
        rules={[
          {
            required: isRequired,
            message: emptyErrorMessage,
            whitespace: isRequired
          }
        ]}
      >
        {textArea ? (
          <Input.TextArea
            className={readOnly ? " readonly-form-field" : "" + fieldClassName}
            placeholder={placeholder}
            id={inputId}
            onChange={onChange}
            maxLength={maxLength}
            disabled={readOnly}
            autoSize={{ minRows }}
          />
        ) : defaultValue ? (
          <Input
            disabled={readOnly}
            className={readOnly ? " readonly-form-field" : "" + fieldClassName}
            placeholder={placeholder}
            defaultValue={defaultValue}
            onChange={onChange}
            maxLength={maxLength}
            type={type ? type : "text"}
            addonAfter={addonAfter ? addonAfter : ""}
          />
        ) : (
          <Input
            disabled={readOnly}
            className={readOnly ? " readonly-form-field" : "" + fieldClassName}
            placeholder={placeholder}
            id={inputId}
            onChange={onChange}
            maxLength={maxLength}
            type={type ? type : "text"}
            addonAfter={addonAfter ? addonAfter : ""}
          />
        )}
      </Form.Item>
    </>
  );
};

export default FormField;
